
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./MegaMenu.css";
import BASE_URL from '../../Config/api';
import men_banner from "../Assets/Frontend_Assets/banner_mens.png";
import women_banner from "../Assets/Frontend_Assets/banner_women.png";
import kids_banner from "../Assets/Frontend_Assets/banner_kids.png";

//const categories = ["stitched", "unstitched", "accessories"];
const categories = [ "unstitched", "Brands"];

const bannerMap = {
  men: men_banner,
  women: women_banner,
  kids: kids_banner,
};
const brandList = [
  "Baroque",
  "Jazmine",
  "Imrozia",
  "Serene",
  "Ramsha",
  "Maria_B",
  "Bin_Ilyias",
  "Saira_Rizwan",
  "Afrozeh",
  "Crimson",
  "Maryium_Hussain",
  "Shagna",
  "Iznik",
  "Khaf",
  "Elaf",
  "Johra",
  "Qalamkar",
  "Rajbari",
  "Ayzel",
  "Mahnur",
  "Parishy",
  "Mushq",
  "Charizma",
  "Eman_Adeel",
  "Nureh",
  "Republic_Women_Wear",
];
const MegaMenu = ({ mainCategory, show, mobile, onClose }) => {
  const [data, setData] = useState({});
  const [openCat, setOpenCat] = useState(null);

  useEffect(() => {
    if (!show) return;

    const fetchData = async () => {
      const result = {};
      for (let cat of categories) {
        const res = await fetch(
          `${BASE_URL}/fabric-types?main_category=${mainCategory}&fabric_category=${cat}`
        );
        result[cat] = await res.json();
      }
      setData(result);
    };

    fetchData();
  }, [show, mainCategory]);

  // if (!show) return null;

  return (
   <div className={`mega-menu ${show ? "show" : ""} ${mobile ? "mobile" : ""}`}>

      <div className="mega-container">
        {/* LEFT IMAGE */}
        {!mobile && (
          <div className="mega-col image-col">
            <img src={bannerMap[mainCategory]} alt={mainCategory} />
          </div>
        )}

        {/* FABRIC COLUMNS */}
        {/* {categories.map((cat) => (
          <div className="mega-col" key={cat}>
            <div
              className="mega-title"
              onClick={() => mobile && setOpenCat(openCat === cat ? null : cat)}
            >
              <h4>{cat}</h4>
              {mobile && <span>{openCat === cat ? "−" : "+"}</span>}
            </div>

            {(openCat === cat || !mobile) &&
              data[cat]?.map((item) =>
                item.fabric_types.map((fabric, i) => (
                  <Link
                    key={i}
                    to={`/category/${mainCategory}/${cat}/${fabric}`}
                    className="mega-link"
                    onClick={onClose}
                  >
                    {fabric}
                  </Link>
                ))
              )}
          </div>
        ))} */}
        {categories.map((cat) => (
  <div className="mega-col" key={cat}>
    <div
      className="mega-title"
      onClick={() => mobile && setOpenCat(openCat === cat ? null : cat)}
    >
      <h4>{cat}</h4>
      {mobile && <span>{openCat === cat ? "−" : "+"}</span>}
    </div>

    {(openCat === cat || !mobile) && (
      <>
        {/* 🔹 If Category is Brands → Show Static Brand List */}
        {cat === "Brands" &&
          brandList.map((brand, i) => (
            <Link
              key={i}
              to={`/category/${mainCategory}/brand/${brand}`}
              className="mega-link"
              onClick={onClose}
            >
              {brand}
            </Link>
          ))}

        {/* 🔹 Otherwise Fetch From API */}
        {cat !== "Brands" &&
          data[cat]?.map((item) =>
            item.fabric_types.map((fabric, i) => (
              <Link
                key={i}
                to={`/category/${mainCategory}/${cat}/${fabric}`}
                className="mega-link"
                onClick={onClose}
              >
                {fabric}
              </Link>
            ))
          )}
      </>
    )}
  </div>
))}
      </div>
    </div>
  );
};

export default MegaMenu;

